<template>
  <div>
    <!-- 1：个推，2：FCM，3：友盟 -->
    <div>
      <md-button :class="{'md-info': msg_plat_type == 1}" @click="() => { msg_plat_type = 1 }" class="md-simple">{{$I18n("one_push")}}</md-button>
      <md-button :class="{'md-info': msg_plat_type == 2}" @click="() => { msg_plat_type = 2 }" class="md-simple">{{$I18n("fcm")}}</md-button>
      <md-button :class="{'md-info': msg_plat_type == 3}" @click="() => { msg_plat_type = 3 }" class="md-simple">{{$I18n("umeng")}}</md-button>
      <md-button :class="{'md-info': msg_plat_type == 4}" @click="() => { msg_plat_type = 4 }" class="md-simple">{{$I18n("jpush")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 1">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP ID"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 2">
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("service_key")}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-50 md-form-item"  @click="clickInput">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required disabled />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
          <div class="md-layout md-layout-item md-size-20 md-xsmall-size-100 mx-auto" style="justify-content: flex-end;"> 
            <md-button class="md-info md-round md-fileinput" @click="clickInput">
              {{$I18n("select_file")}}
            </md-button>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 3">
      <!-- 平台应用ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_id}">
              <md-input v-model="msg_plat_conf_form.access_id" required />
              <md-icon v-if="error.access_id">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Umeng Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <div v-if="msg_plat_type == 4">
      <!-- 平台应用 KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"APP Key"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.access_key}">
              <md-input v-model="msg_plat_conf_form.access_key" required />
              <md-icon v-if="error.access_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 平台应用Secret KEY -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{"Master Secret"}}<i :style="{color: 'red'}">*</i>:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field :class="{'md-error' : error.secret_key}">
              <md-input v-model="msg_plat_conf_form.secret_key" required />
              <md-icon v-if="error.secret_key">clear</md-icon>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 小米渠道ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("xm_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.xm_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- OPPO ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("oppo_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.oppo_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 本地通知 ID -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("notif_ch_id")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.notif_ch_id" />
            </md-field>
          </div>
        </div>
      </div>
      <!-- 打开方式 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_type")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-select v-model="msg_plat_conf_form.open_type">
                <!-- <md-option :value="0">{{$I18n("none")}}</md-option> -->
                <md-option :value="1">{{$I18n("open_app")}}</md-option>
                <md-option :value="2">{{$I18n("open_activity")}}</md-option>
                <md-option :value="3">{{$I18n("open_url")}}</md-option>
              </md-select>
            </md-field>
          </div>
        </div>
      </div>
      <!-- 启动参数 -->
      <div class="md-layout">
        <div class="md-layout md-layout-item md-size-80 md-xsmall-size-100 mx-auto"> 
          <label class="md-layout-item md-size-30 md-form-label md-form-label-out">
            {{$I18n("open_param")}}:
          </label>
          <div class="md-layout-item md-size-70 md-form-item">
            <md-field>
              <md-input v-model="msg_plat_conf_form.open_param" />
            </md-field>
          </div>
        </div>
      </div>
      <md-button @click="modal_openModal" class="md-info right-button">{{$I18n("sure")}}</md-button>
    </div>
    <!-- 弹窗 -->
    <modal key="main" v-show="modal" @close="modal_closeModal" class="lg-modal">
      <!-- 弹窗-头部 -->
      <template slot="header">
        <h4 class="modal-title">{{$I18n("tips")}}</h4>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modal_closeModal">
          <md-icon>clear</md-icon>
        </md-button>
      </template>
      <!-- 弹窗-主体 -->
      <template slot="body">
        <div>{{$I18n("is_sure_edit")}}</div>
      </template>
      <!-- 弹窗-底部按钮 -->
      <template slot="footer">
        <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
        <md-button @click="modal_closeModal" class="">{{$I18n("cancel")}}</md-button>
      </template>
    </modal>
    <input :ref="'file_input'" style="display: none;" type="file" @change="onFileChange_url"/>
  </div>
</template>
<script>
import { Modal } from '@/components';
export default {
  components: {
    Modal,
  },
  props: {
    app_id : {
      type: String,
      default: "",
    },
  },
  data(){
    return {
      modal: false, // 弹窗是否打开了
      error:{},
      msg_plat_type: 1,
      msg_plat_conf_form: {
        access_id  : "",
        access_key : "",
        secret_key : "",
        xm_ch_id   : "",
        open_type  : 1,
        notif_ch_id: "",
        open_param : "",
        oppo_ch_id : "",
      },
    }
  },
  methods: {
    // (file发生变化)
    onFileChange_url ($event) {
      this.onFileSelected($event)
    },
    onFileSelected ({ target, dataTransfer }) {
      const files = target.files || dataTransfer.files;
      this.getFileName(files, target);
    },
    getFileName(files, target) {
      if (!files || files.length === 0) {
        return target.value.split('\\').pop()
      }
      if (files.length > 1) {
        return this.getMultipleName(files)
      }
      if (files.length === 1) {
        var formData = new FormData();
        formData.append('myfile', files[0]);
        this.$api.uploadFile(formData)
          .then(this.$Then(res => {
            this.msg_plat_conf_form.access_key = res.data;
            this.$refs.file_input.value = "";
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
        return files[0].name;
      }
      return null
    },
    clickInput(){ // 图片插件-点击按钮 触发 img input
      this.$refs.file_input.click();
    },
    modal_openModal (){ // 弹窗-打开弹窗
      this.modal = true;
    },
    modal_closeModal(){ // 弹窗-关闭弹窗
      this.modal = false;
    },
    api_getMsgPlatInit(){
      return this.$api.getMsgPlatform({
        app_id : this.app_id,
        type : this.msg_plat_type,
      })
        .then(this.$Then(res => {
          if(res.data && res.data.length > 0 && res.data[0].id){
            this.msg_plat_conf_form = {
              ...res.data[0],
              open_type : res.data[0].open_type ?res.data[0].open_type :1,
            }
            if(this.msg_plat_type == 2){
              this.msg_plat_conf_form.access_key = res.data[0].secret_file;
            }
          } else {
            this.msg_plat_conf_form = {
              access_id   : "",
              access_key  : "",
              secret_key  : "",
              xm_ch_id    : "",
              open_type   : 1,
              open_param  : "",
              oppo_ch_id  : "",
              notif_ch_id : "",
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    modal_submit(){ // 弹窗-提交修改
      this.error = {
        access_id :   !this.msg_plat_type == 4 && !this.msg_plat_conf_form.access_id ,
        access_key  : !this.msg_plat_conf_form.access_key ,
        secret_key  : !this.msg_plat_type == 2 && !this.msg_plat_conf_form.secret_key ,
      }
      for(var key in this.error){
        if(this.error[key]){
          // this.modal = false;
          this.$errorMsg(this.$I18n("pls_check_verify"))
          return 
        }
      }
      return this.$api.editMsgPlatform({
        ...this.msg_plat_conf_form,
        secret_file: this.msg_plat_type == 2 ?this.msg_plat_conf_form.access_key: "",
        access_key : this.msg_plat_type != 2 ?this.msg_plat_conf_form.access_key: "",
        type : this.msg_plat_type,
        app_id: this.app_id,
      })
        .then(this.$Then(() => {
          this.modal = false;
          this.api_getMsgPlatInit();
          this.$successMsg(this.$I18n("edit_success"));
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
  },
  watch:{
    msg_plat_type(){
      this.api_getMsgPlatInit();
    },
  },
  created(){
    this.api_getMsgPlatInit();
  },
}
</script>